import {
  AfterViewInit,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { state, style, trigger } from '@angular/animations';

// NOTE: this magic is for calculating approx value to make
// opened results to be full height
// TODO: implement more clean solution
const START_HEIGHT = window.innerHeight - 650;

@Component({
  selector: 'app-expand',
  templateUrl: './expand.component.html',
  styleUrls: ['./expand.component.scss'],
  animations: [
    trigger('collapse', [
      state(
        'expanded',
        style({
          maxHeight: '2000px',
        })
      ),
      state(
        'collapsed',
        style({
          maxHeight: '{{startHeight}}',
        }),
        {
          params: { startHeight: `${START_HEIGHT}px` },
        }
      ),
    ]),
  ],
})
export class ExpandComponent implements AfterViewInit {
  @Input() expanded = false;
  @Output() public stateChange = new EventEmitter();

  @ContentChild('expandableContentRef') content: ElementRef;
  showToggle: boolean = true;

  toggle(): void {
    this.expanded = !this.expanded;
    this.stateChange.emit(this.expanded);
  }

  ngAfterViewInit(): void {
    this.handleToggleVisibility();
  }

  handleToggleVisibility(): void {
    const contentElement: HTMLElement = this.content.nativeElement;

    this.showToggle = contentElement.clientHeight >= START_HEIGHT;
  }
}
